import SidebarContainer from '@efdigital/ll-xceed-v2/components/application/sidebar-container.gts';
import type { CoachingCoachModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

const NAV = [
  {
    link: {
      route: 'coaching.coach.index',
    },
    icon: 'ph:squares-four',
    label: 'Dashboard',
  },
  {
    link: {
      route: 'coaching.coach.sessions',
    },
    icon: 'ph:calendar',
    label: 'Sessions',
  },
  {
    link: {
      route: 'coaching.coach.settings',
    },
    icon: 'ph:gear',
    label: 'Settings',
  },
];

interface CoachSignature {
  Args: {
    model: CoachingCoachModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Coach"}}

  <SidebarContainer @nav={{NAV}}>
    <:content>
      {{outlet}}
    </:content>
  </SidebarContainer>
</template> satisfies TOC<CoachSignature>;
